import styled from "styled-components";

export const LoadingMessage = styled.div`
  font-size: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
`;
